/**
 * Copyright (c) 20240701, Mohamed eRrais (merrais / MeR) 
 * from tajwyd.akademy.ma
 * logo.png Compressed from digitalservices.ma
 * from sync.2us.ma 
 */

import {base} from '../app'

export const enConfig = {
    ...base,
    bismi : 'In the name of God, the Most Gracious, the Most Merciful.',
    salaam :'Salaam',

    header:{
        joinus : "Join us",
        signin : "Login",    
        signout: "Exit",
        close: "Close",
        profile: "Profile",
        email: "Email",
        phone: "Phone",
        signup : "Sign Up for a better health",
        about : "About",
        article : "Articles",
        contact : "Contact",
        download: "Get App",
    },
    
    home:{
        title:base.name, 
        login:'Login',
        about:'About',
        article:'Articles',
        contact:'Contact',
        connected: 'You must be registered'
    },

    blog:{
        title :'Most Interesting Articles',
        read:'Read more...'
    },

    contact:{
        title:'Get In Touch',
        message:'Please fill out the form below to send us an email',
        confirm:'Contact Confirming',
        content:'Please fill out the code we sent you by email to confirm it',
        recipient:"Please confirm the recipient's information.",
        feedback : 'We have received your message, we will get back to you as soon as possible',
        warning : "Need to confirm your email before proceeding"
    },

    about:{
        title:'Healthier',
        content:'Using Tech and AI to make people healthier',
    },


    getApp : {
        name : 'Download Services App',
        info : 'Download Services App',
        label : 'Download Services App'
    },

}
